module.exports = __webpack_public_path__ + "img/ic_msg.f4a3a4be.png";